import * as actionTypes from 'redux/actions'
import { removePlacements } from 'utils/removePlacements'

export const STBCarouselPlacement = {
  name: 'TV - Carousel Ad',
  type: 'stb_carousel_ad'
}

export const STBMoviesAndSeriesBannerPlacement = {
  name: 'TV Movies & Series Banner',
  type: 'stb_movie_series_bannar'
}

export const STBChannelBannerPlacement = {
  name: 'TV - Channel Banner',
  type: 'stb_channel_bannar'
}

export const STBDetailBannerPlacement = {
  name: 'TV - Detail Banner',
  type: 'stb_detail_bannar'
}

const defaultPlacements = {
  cards: {
    STBCarousel: STBCarouselPlacement,
    STBMoviesAndSeriesBanner: STBMoviesAndSeriesBannerPlacement,
    STBDetailBanner: STBDetailBannerPlacement,
    STBChannelBanner: STBChannelBannerPlacement,

    STBBanner: {
      name: 'TV - Banner',
      file: '',
      Info: '',
      title: '',
      hyperlink: '',
      description: '',
      type: 'stb_bannar'
    },
    STBHalfBanner: { name: 'TV - Info Banner', type: 'stb_half_bannar' },
    STBSidebarBanner: {
      name: 'TV - List Banner',
      type: 'stb_sidebar_bannar'
    },
    STBPopup: { name: 'TV - Pop up', type: 'stb_popup' },
    STBThread: { name: 'TV - Thread', type: 'stb_thread' },
    STBSkippable: { name: 'TV - Skippable Ad', type: 'stb_s_ad' },
    STBUnskippable: { name: 'TV - Unskippable Ad', type: 'stb_un_ad' },

    AppBanner: { name: 'App - Banner', type: 'app_bannar' },
    AppDetailBanner: {
      name: 'App - Detail Banner',
      type: 'app_detail_bannar'
    },
    AppCarouselAd: { name: 'App - Carousel Ad', type: 'app_carousel_ad' },
    AppPopup: { name: 'App - PopUp', type: 'app_popup' },
    AppSkippable: { name: 'App - Skippable Ad', type: 'app_s_ad' },
    AppUnskippable: { name: 'App - Unskippable Ad', type: 'app_un_ad' },

    // Deprecated
    STBSquareBanner: { name: 'TV - Square Banner', type: 'stb_square_bannar' },
    STBMainBanner: { name: 'TV - Main Banner', type: 'stb_main_bannar' }
  },
  SelectedCard: {
    type: 'image'
  }
}

const initialState = {
  Step: 0,
  name: '',
  isNewCampaign: false,
  placement: { ...defaultPlacements },
  strategies: {
    v: false,
    d: false,
    t: false
  },
  startDate: new Date(),
  endDate: new Date(new Date().setMonth(new Date().getMonth() + 1)),
  TVChannelsCategories: [],
  moviesCategories: [],
  TVSeriesCategories: [],
  age: '',
  locations: [],
  audience: [],
  refreshAudience: 0
}

const newCampaignReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_FILE:
      const cards = { ...state.placement.cards }
      if (action.payload.loading) {
        cards[state.placement.SelectedCard.name].loading = true
        cards[state.placement.SelectedCard.name].failed = false
        state.placement.SelectedCard.loading = true
      } else if (action.payload.failed) {
        cards[state.placement.SelectedCard.name].failed = true
        cards[state.placement.SelectedCard.name].loading = false
        state.placement.SelectedCard.loading = false
        cards[state.placement.SelectedCard.name].file = null
      } else {
        cards[state.placement.SelectedCard.name].file = action.payload.file
        cards[state.placement.SelectedCard.name].Info = action.payload.Info
        cards[state.placement.SelectedCard.name].loading = false
        cards[state.placement.SelectedCard.name].failed = false
        state.placement.SelectedCard.loading = false
      }

      return {
        ...state,
        placement: {
          ...state.placement,
          cards: {
            ...cards
          }
        }
      }
    case actionTypes.SET_LAST_STEP:
      return {
        ...state,
        lastStep: action.payload,
        Step: 0
      }
    case actionTypes.SET_STEP: {
      if (action.payload === 1)
        return {
          ...state,
          isNewCampaign: true,
          Step: action.payload
        }
      return {
        ...state,
        Step: action.payload
      }
    }
    case actionTypes.SELECT_CARD: {
      if (!state.placement.cards[action.payload.name]) {
        state.placement.cards = {
          ...state.placement.cards,
          [action.payload.name]: {}
        }
      }
      return {
        ...state,
        placement: {
          ...state.placement,
          SelectedCard: action.payload
        }
      }
    }
    case actionTypes.SELECT_PACKAGE: {
      return {
        ...state,
        adPackage: action.payload
      }
    }
    case actionTypes.SELECT_PLATFORM: {
      return {
        ...state,
        platform: action.payload
      }
    }
    case actionTypes.SET_BRAND: {
      return {
        ...state,
        brand: action.payload
      }
    }
    case actionTypes.SELECT_STRATEGY:
      const strategies = { ...state.strategies }
      if (action.payload === false)
        return {
          ...state,
          strategies: {
            v: false,
            d: false,
            t: false
          }
        }
      if (action.payload?.includes('false')) {
        strategies[action.payload?.split('_')[0]] = false
        return { ...state, strategies }
      }

      strategies[action.payload] = !strategies[action.payload]
      return { ...state, strategies }

    case actionTypes.SELECT_VISUAL_TYPE: {
      return {
        ...state,
        visualType: action.payload
      }
    }
    case actionTypes.CAMPAIGN_NAME: {
      return {
        ...state,
        name: action.payload
      }
    }
    case actionTypes.SET_TV_CHANNELS: {
      return {
        ...state,
        TVChannelsCategories: action.payload
      }
    }
    case actionTypes.SET_MOVIES: {
      return {
        ...state,
        moviesCategories: action.payload
      }
    }
    case actionTypes.SET_TV_SEIRES: {
      return {
        ...state,
        TVSeriesCategories: action.payload
      }
    }
    case actionTypes.TITLE:
      state.placement.cards[state.placement.SelectedCard.name]['title'] =
        action.payload
      return {
        ...state,
        title2: action.payload
      }
    case actionTypes.HYPERLINK: {
      state.placement.cards[state.placement.SelectedCard.name]['hyperlink'] =
        action.payload
      return {
        ...state,
        hyperlink2: action.payload
      }
    }

    case actionTypes.DESCRIPTION: {
      state.placement.cards[state.placement.SelectedCard.name]['description'] =
        action.payload
      return {
        ...state,
        description2: action.payload
      }
    }
    case actionTypes.AUDIENCE: {
      return {
        ...state,
        audience: action.payload
      }
    }
    case actionTypes.REFRESH_AUDIENCE: {
      return {
        ...state,
        refreshAudience: state.refreshAudience + 1
      }
    }
    case actionTypes.SET_CAMPAIGN_PRICE: {
      return {
        ...state,
        campaignPrice: action.payload
      }
    }
    case actionTypes.ADD_LOCATION: {
      return {
        ...state,
        locations: [...state.locations, action.payload]
      }
    }
    case actionTypes.LOCATIONS: {
      return {
        ...state,
        locations: action.payload
      }
    }
    case actionTypes.UPDATE_LOCATION: {
      const newLocations = state.locations?.map((location) => {
        if (location?.id === action?.payload?.id) return action.payload
        return location
      })
      return {
        ...state,
        locations: newLocations
      }
    }
    case actionTypes.START_DATE: {
      return {
        ...state,
        startDate: action.payload
      }
    }
    case actionTypes.END_DATE: {
      return {
        ...state,
        endDate: action.payload
      }
    }
    case actionTypes.SET_BUDGET: {
      return {
        ...state,
        budget: action.payload
      }
    }
    case actionTypes.RESET_CAMPAIGN: {
      removePlacements(state.placement.cards, action.payload)
      return {
        Step: 0,
        name: '',
        isNewCampaign: false,
        placement: defaultPlacements,
        strategies: {
          v: false,
          d: false,
          t: false
        },
        startDate: new Date(),
        endDate: new Date(new Date().setMonth(new Date().getMonth() + 1)),
        TVChannelsCategories: [],
        moviesCategories: [],
        TVSeriesCategories: [],
        age: '',
        locations: []
      }
    }
    case actionTypes.RESET_PLACEMENTS: {
      removePlacements(state.placement.cards, action.payload)
      return {
        ...state,
        placement: defaultPlacements
      }
    }
    case actionTypes.ADD_CATEGORIES: {
      return { ...state, categories: action.payload }
    }
    default: {
      return state
    }
  }
}

export default newCampaignReducer
